<template>
    <div>
        <div class="mt3 th mb3 flex items-center ba b--light-gray h2">
                <img class="ph2" src="@/assets/img/icon_search_location.svg"/>
                Winnipeg
        </div>

        <DatesSelection/>

        <!-- sliders -->
        <SliderFilter label="Distance" :min="1" :max="50" v-model="filters.distance" @drag-end="filterChanged" class="mt4 mb3">
            Within <h6 class="dib">{{ filters.distance }} KM</h6>
        </SliderFilter>
        <SliderFilter label="Price" :min="1" :max="1500" v-model="filters.price" @drag-end="filterChanged" class="mb3">
            <h6 class="dib">${{ filters.price }}</h6> / day or less
        </SliderFilter>
        <SliderFilter label="Rating" :min="1" :max="5" :interval=".5" v-model="filters.rating" @drag-end="filterChanged" class="mb3">
            <h6 class="dib">{{ filters.rating }}</h6><img class="mh1" src="@/assets/img/icon_star.svg"/>or more
        </SliderFilter>

        <!-- dropdowns -->
        <select class="th mv3 ph2 w-100">
            <option value="0">All Projects</option>
        </select>
        <select class="th ph2 mb3 w-100">
            <option value="0">All Categories</option>
        </select>
        <select class="th ph2 w-100">
            <option value="0">All Brands</option>
        </select>

        <div class="pv4 tc">
        <TooliabaButton class="mb3 ">Apply Filters</TooliabaButton>
        <a class="link pointer" @click="resetFilters"><h6 class="grow mid-gray  ">Reset Filters</h6></a>
        
        </div>
    </div>
</template>

<script>
import DatesSelection from '@/components/global/DatesSelection.vue';
import Slider from '@/components/controls/Slider.vue';
import SliderFilter from '@/components/search/SliderFilter.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

const DEFAULTS = {
    distance: 15,
    price: 901,
    rating: 3
};

export default {
    components: {
        DatesSelection,
        Slider,
        SliderFilter,
        TooliabaButton
    },
    data() {
        return {
            filters: null
        };
    },
    props: {
        applyImmediately: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        resetFilters() {
            var query = this.$route.query;

            this.filters = {
                distance: parseInt(query.distance) || DEFAULTS.distance,
                price: parseInt(query.price) || DEFAULTS.price,
                rating: parseFloat(query.rating) || DEFAULTS.rating
            };
        },
        applyFilters() {
            var diff = {};

            Object.keys(this.filters)
                .filter(x => this.filters[x] !== DEFAULTS[x])
                .forEach(x => (diff[x] = this.filters[x]));

            this.$router.push({
                path: '/search',
                query: Object.assign({}, this.$route.query, diff)
            });
        },
        filterChanged() {
            if (this.applyImmediately) {
                this.applyFilters();
            }
        }
    },
    created: function() {
        this.resetFilters();
    },
    watch: {
        '$route.query'() {
            this.resetFilters();
        }
    }
};
</script>
